import { BlockError } from '@/blocks.04-project/block-error/block-error';
import { LazyInit } from '@/blocks.04-project/lazy-init/lazy-init';
import throttle from 'lodash-es/throttle';

/***
 * Класс отзыва
 * @example
 *
 * Переменные:
 * --text-max-height - максимальная высота текста для обрезания текста
 *
 * Классы:
 * review_overflow - вешается для обрезания текста до трёх строк
 *
 */
class Review {
	/***
	 * Конструктор класса
	 * @param elem {HTMLElement} DOM элемент с классом review
	 * @param force {Boolean|undefined} принудительно инициализирование
	 */
	constructor ({ elem, force}) {
		this.BlockError = new BlockError({ blockName: 'Review', destroy: this.destroy });
		if (!elem) return this.BlockError.error('Отсутствует elem');

		this.block = elem;
		this.block.Review = this;

		this.LazyInit = new LazyInit({ ins: this, callback: this.init, addClass: 'review_inited' });
		this.LazyInit.init();
		if (force) this.LazyInit.earlyInit();
	}

	init = async () => {
		this.textElement = this.block.querySelector('.review__text span');
		if (!this.textElement) return this.BlockError.error('Отсутствует .review__text span');

		this.textMaxHeight = parseInt(getComputedStyle(this.block).getPropertyValue('--text-max-height'));

		this.toggleOverflow();
		window.addEventListener('resize', this.resize);
	};

	resize = throttle(() => {
		this.toggleOverflow();
	}, 200);

	toggleOverflow = () => {
		this.block.classList.toggle('review_overflow', this.textElement.offsetHeight > this.textMaxHeight);
	};

	destroy = () => {
		if (this.LazyInit) this.LazyInit.destroy();
		if (this.block) {
			window.removeEventListener('resize', this.resize);
			this.block.classList.remove('review_inited');
			delete this.block.Review;
		}
	};

	static init ({ container = document, force = false } = {}) {
		Array.from(container.querySelectorAll('.review:not(.review_inited)')).forEach((elem) => new Review({
			elem,
			force
		}));
	}
}

document.addEventListener('DOMContentLoaded', () => Review.init());

// Экспорт;
window.Block.Review = Review;
